module.exports = __webpack_public_path__ + "static/media/Doklad_OK_2018.2786e25c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2019/Doklad_OK_2018.pdf
// module id = 129
// module chunks = 0